var map = {
	"./1 The Emergency of Kali copy.jpg": 4262,
	"./2 The Emergency of Kali.jpg": 1898,
	"./3 The Emergency of Kali copy.jpg": 5684,
	"./4 The Emergency of Kali copy.jpg": 4125,
	"./6 The Emergency of Kali copy.jpg": 8467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7434;